import styled from 'styled-components';
import { Show } from '@elfsight/lib-utils';
import { focusVisibleMixin } from '@elfsight/widget-ui';
import { useSettings } from '@wu/widget-core';
import { SectionsLayout } from '../sections-layouts';
import { useData } from './DataProvider';
import { Info } from './Info';

export function MenuItem() {
  const {
    metadata: { id, footerText }
  } = useData();

  const { showMenuTitle, menusLayout } = useSettings();

  const isTabsLayout = menusLayout === 'tabs';
  const tabsProps = isTabsLayout
    ? {
        role: 'tabpanel',
        'aria-labelledby': id
      }
    : {};

  return (
    <MenuComponent {...tabsProps}>
      <Show when={showMenuTitle || !isTabsLayout}>
        <Heading>
          <Info />
        </Heading>
      </Show>

      <SectionsLayout />
      <Show when={!!footerText}>
        <ItemFooterText
          dangerouslySetInnerHTML={{
            __html: footerText!
          }}
        />
      </Show>
    </MenuComponent>
  );
}

const MenuComponent = styled.div`
  &:not(&:first-child) {
    margin-top: 48px;
  }
`;

const Heading = styled.div`
  overflow: hidden;
  margin-bottom: 32px;
`;

export const ItemFooterText = styled.div`
  margin-top: 16px;
  font-size: 14px;
  line-height: 1.125;
  opacity: 0.65;
  text-align: center;

  & a {
    ${focusVisibleMixin()}
  }
`;
